import * as types from '../constants/ActionTypes';

const authentication= (state = false, action) => {
  switch (action.type) {
    case types.VALIDATE_USERNAME_PENDING:
      return {
        ...state,
        validateUsernamePending: action.validateUsernamePending,
      }

    case types.VALIDATE_USERNAME_SUCCESS:
      return {
        ...state,
        validateUsernameSuccess: action.validateUsernameSuccess
      }

    case types.VALIDATE_USERNAME_ERROR:
      return {
        ...state,
        validateUsernameError: action.validateUsernameError,
        validateUsernameErrorMessage: action.validateUsernameErrorMessage,
      }

    case types.SIGNUP_PENDING:
      return {
        ...state,
        signupPending: action.signupPending,
        isAuthenticated: false
      }

    case types.SIGNUP_SUCCESS:
      return {
        ...state,
        signupSuccess: action.signupSuccess,
        isAuthenticated: true
      }

    case types.SIGNUP_ERROR:
      return {
        ...state,
        signupError: action.signupError,
        isAuthenticated: false
      }

    case types.LOGIN_PENDING:
      return {
        ...state,
        isLoginPending: action.loginPending,
        isAuthenticated: false
      }

    case types.LOGIN_SUCCESS:
      return {
        ...state,
        isLoginSuccess: action.loginSuccess,
        isAuthenticated: true
      }

    case types.LOGIN_ERROR:
      return {
        ...state,
        loginError: action.loginError,
        isAuthenticated: false
      }

    case types.LOGOUT_SUCCESS:
      return {
        ...state,
        isLogoutPending: false,
        isAuthenticated: false
      }

    case types.ME_FROM_TOKEN:
      return { 
        ...state, 
        isAuthenticated: false, 
        error: null, 
        isTokenPending: true
      }; 

    case types.ME_FROM_TOKEN_SUCCESS:
      return { 
        ...state, 
        isAuthenticated: true, 
        error: null, 
        isTokenPending: false 
      }; 

    case types.ME_FROM_TOKEN_FAILURE:
      let error = action.payload[1] || { message: action.payload[1].message }; // 2nd one is network or server down errors   
      return { 
        ...state, 
        isAuthenticated: false,
        error: error, 
        isTokenPending: false
      };

    case types.RESET_TOKEN:
      return {
        ...state, 
        isAuthenticated: false,
        error: null, 
        isTokenPending: false
      };

    default:
      return state;
  }
}

export default authentication;


// WEBPACK FOOTER //
// ./src/store/reducers/authentication.js